<template>
  <div class="subproperty-wallet">
    <app-stripe-wallet-widget-page />
  </div>
</template>

<script>
import StripeWalletWidgetPage from '@modules/stripe/stripe-wallet/components/stripe-wallet-widget-page.vue'
import StripeEnabledGuardMixin from '@modules/stripe/mixins/stripe-enabled-guard-mixin'

export default {
  name: 'app-subproperty-wallet',
  mixins: [StripeEnabledGuardMixin],
  components: {
    [StripeWalletWidgetPage.name]: StripeWalletWidgetPage,
  },
}
</script>
